import { render, staticRenderFns } from "./B2BDeliverySection.vue?vue&type=template&id=3e42b079&scoped=true"
import script from "./B2BDeliverySection.vue?vue&type=script&setup=true&lang=ts"
export * from "./B2BDeliverySection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./B2BDeliverySection.vue?vue&type=style&index=0&id=3e42b079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e42b079",
  null
  
)

export default component.exports